import axios, {AxiosResponse} from 'axios';

interface OkResponse<T>
{
	ok: true;
	data: T;
}

interface ErrorResponse
{
	ok: false;
	message: string;
}

export type BaseResponse<T> = OkResponse<T> | ErrorResponse;

export class UserFacingError
{
	public readonly message: string;

	public constructor (message: string)
	{
		this.message = message;
	}
}

export class BaseApi
{
	public static Get<Req, Res> (path: string, query: Req): Promise<Res>
	{
		return BaseApi.MakeAxiosRequest(axios.get(path, {params: query}));
	}

	public static Post<Req, Res> (path: string, body: Req): Promise<Res>
	{
		return BaseApi.MakeAxiosRequest(axios.post(path, body));
	}

	private static MakeAxiosRequest<T> (axiosRequest: Promise<AxiosResponse<BaseResponse<T>>>)
	{
		return axiosRequest
			.then((result) =>
			{
				if (result.data.ok !== true)
				{
					throw new Error(result.data.message);
				}
				return result.data.data;
			})
			.catch((err) =>
			{
				console.error(err);
				if (err.response && err.response.data && err.response.data.message && err.response.data.friendly)
				{
					throw new UserFacingError(err.response.data.message);
				}
				throw err;
			});
	}
}
